<template>
  <div>
    <multi-park-tickets></multi-park-tickets>
    <el-row class="margintop20" type="flex" justify="center">
      <el-button @click="handleClick">{{ $t('button.cancel') }}</el-button>
      <el-button type="primary" @click="handleClick">{{ $t('button.confirm') }}</el-button>
    </el-row>
  </div>
</template>

<script>
import multiParkTickets from '@/views/zooTicketsManager/multiParkTickets/list/index.vue'

export default {
  components: {
    multiParkTickets
  },
  methods: {
    handleClick () {
      this.$router.push({
        name: 'zooTicketsList'
      })
    }
  }
}
</script>

<style>

</style>
